"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForm = void 0;
const react_1 = require("react");
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const useForm = (initialValues = {}) => {
    const [formValues, setFormValues] = (0, react_1.useState)(initialValues);
    const setFormValue = (0, react_1.useCallback)((key, value, callback) => {
        setFormValues((prevFormValues) => {
            const prevFormValue = prevFormValues === null || prevFormValues === void 0 ? void 0 : prevFormValues[key];
            if (!(0, fast_deep_equal_1.default)(prevFormValue, value)) {
                const newFormValues = Object.assign({}, prevFormValues);
                newFormValues[key] = value;
                if (callback)
                    setTimeout(() => callback(newFormValues), 0);
                return newFormValues;
            }
            if (callback)
                setTimeout(() => callback(prevFormValues), 0);
            return prevFormValues;
        });
    }, [setFormValues]);
    const resetFormValues = (0, react_1.useCallback)((data = {}) => {
        setFormValues(data);
    }, [setFormValues]);
    return { formValues, setFormValue, resetFormValues };
};
exports.useForm = useForm;
//# sourceMappingURL=useForm.js.map